<template>
  <div>
    <Card>
      <Row>
        <Button type="info"
                @click="add">{{$t('pages_banners_index_178')}}</Button>
      </Row>
      <TablePaginate :columns="columns"
                     :data="users_shops"
                     :loading="loading"
                     :meta="meta"
                     :changePage="changePage">
      </TablePaginate>
    </Card>
    <Modal v-model="modalShow"
           @on-ok="handleSubmit"
           :title="$t('pages_user_shops_index_1139')">
      <Form ref="users_shop"
            :model="users_shop"
            :label-width="120">
        <Form-item :label="$t('pages_user_shops_index_1140')"
                   prop="username">
          <Input type="text"
                 v-model="users_shop.username" />
        </Form-item>
        <Form-item v-if="!users_shop.id"
                   :label="$t('pages_suppliers_index_1135')"
                   prop="mobile">
          <Input type="text"
                 v-model="users_shop.mobile" />
        </Form-item>
        <Form-item :label="$t('pages_roles_index_912')"
                   prop="role_id">
          <Select v-model="users_shop.role_id">
            <Option v-for="role in roles"
                    :key="role.id"
                    :value="role.id">{{ role.name }}</Option>
          </Select>
        </Form-item>
        <!-- <Form-item label="所属推广公司"
                   prop="promote_company">
          <Select v-model="users_shop.promote_company">
            <Option :value="company.id" v-for="company in promote_companies" :key="company.id">{{company.name}}</Option>
          </Select>
        </Form-item> -->
        <!-- <Form-item label="联系人密码" prop="password">
          <Input type="text" v-model="users_shop.password" />
        </Form-item> -->
      </Form>
    </Modal>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapGetters, mapState, mapActions, mapMutations } from 'vuex'
import TablePaginate from '@/components/TablePaginate'
import { deleteButtonInTable, editorButtonInTable } from '@/libs/table-render'
// import { get as _get } from 'lodash';

export default {
  components: {
    TablePaginate
  },
  data () {
    return {
      modalShow: false,
      formType: '',
      columns: [
        {
          title: i18n.t('pages_user_shops_index_1140'),
          align: 'center',
          key: 'username',
          render: (h, params) => {
            return h('div', [
              params.row.username,
              params.row.role === i18n.t('libs_util_102') ? h('Badge', { props: { text: i18n.t('libs_util_102'), type: 'primary' }, style: { 'margin-left': '4px' } }) : ''
            ])
          }
        },
        {
          title: i18n.t('pages_suppliers_index_1135'),
          width: 180,
          align: 'center',
          key: 'user_display_mobile'
        },
        {
          title: i18n.t('pages_roles_index_912'),
          key: 'role',
          width: 100,
          align: 'center',
          // render: (h, params) => {
          //   const roleName = _get(params.row, ['roles', 0, 'name'], '');
          //   return h('div', roleName)
          // }
        },
        {
          title: i18n.t('pages_balance_transaction_index_177'),
          width: 200,
          align: 'center',
          key: 'created_at_str'
        },
        {
          title: i18n.t('pages_ai_image_163'),
          key: 'action',
          width: 200,
          fixed: 'right',
          align: 'center',
          render: (h, params) => {
            const children = []
            children.push(deleteButtonInTable(this, h, params))
            children.push(editorButtonInTable(this, h, params))
            return h('div', children)
          }
        }
      ]
    }
  },
  created () {
    this.changeQuery({ page: 1 })
    this.index()
    this.fetchRoles({ per: 65535 })
    // this.companyIndex()
  },
  computed: {
    ...mapGetters('users_shop', [
      'users_shop',
      'users_shops',
      'meta',
      'loading'
    ]),
    // ...mapGetters('promote_company', ['promote_companies']),
    ...mapState('role', ['roles']),
  },
  watch: {
    users_shop: {
      immediate: false,
      async handler (value) {
        if (value.origin_role) {
          this.users_shop.role_id = value.origin_role.id
        }
      }
    }
  },
  methods: {
    ...mapActions('users_shop', [
      'clear',
      'index',
      'show',
      'create',
      'update',
      'destroy'
    ]),
    ...mapActions('role', { fetchRoles: 'index' }),
    // ...mapActions('promote_company', { companyIndex: 'index' }),
    ...mapMutations('users_shop', ['changeQuery']),
    changePage (page) {
      this.changeQuery({ page: page })
      this.index()
    },
    add () {
      this.clear()
      this.modalShow = true
      this.formType = 'new'
    },
    async handleSubmit () {
      if (this.formType === 'edit') {
        await this.update(this.users_shop)
      } else if (this.formType === 'new') {
        await this.create(this.users_shop)
      }
      this.modalShow = false
    }
  }
}
</script>
